import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppPreloadingStrategy } from './app-preloading.strategy';
import { AuthGuard } from './modules/core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    loadChildren: () => import('@app/modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'portal',
    loadChildren: () => import('@app/modules/portal/portal.module').then(m => m.PortalModule),
    canActivate: [AuthGuard],
    data: { preload: true }

  },
  { path: '**', redirectTo: 'not-found' }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: AppPreloadingStrategy,
      scrollPositionRestoration: 'top',
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule],
  providers: [AppPreloadingStrategy]
})
export class AppRoutingModule {}
